import { api } from "@/APIRequests";
import type { PatientDiagnosis } from "@/core/types";

export async function getPatientDiagnosis(patientId: string): Promise<PatientDiagnosis> {
  return api.shared.get_patient_diagnosis({
    urlParams: { patientId },
  }) as unknown as Promise<PatientDiagnosis>;
}
